import React, { useEffect, useRef, useState } from "react";
import nodeinstance from "../../../../nodeInstance";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import SecDeposite from "../../DummyPdfs/visacostSecdepositePDF/SecdepositePDF";
import { BsCloudDownload } from "react-icons/bs";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useNavigate } from "react-router-dom";
import { CgSpinner } from "react-icons/cg";

export default function Visacostsunmodule({
  propData,
  quotationType,
  contractId,
  setSummaryData,
  trigger,
  contractNumber,
  setSelectedData,
  Qunatity,
}) {
  console.log("fgyygfryyugu....dctftyd.....propData..", propData);
  const Data = [
    {
      id: 1,
      name: "Sridhar",
    },
  ];
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const tableHeading2 = [
    {
      bgPrimary: "bg-green-400",
      bgSecondary: "bg-green-200",
    },
  ];
  const tableHeading2_SUB = [
    {
      bgPrimary: "bg-pink-400",
      bgSecondary: "bg-pink-200",
    },
  ];
  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2.5rem]",
    itemHeight: "h-[3rem]",
  };
  const tableProperties2 = {
    colWidth: "w-48",
    colHeight: "h-[3rem]",
    itemHeight: "h-[3rem]",
  };
  const [data, setData] = useState();
  const [quantities, setQuantities] = useState([]);
  const [depositecost, SetDepositeCost] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [visaCost, setVisaCost] = useState([]);

  const [secDepositeDropDown, setSecDepositeDrop] = useState();
  const [secData, setSecData] = useState();
  const [visacostcomments, setVisaCostComments] = useState();
  const [secComments, setSecComments] = useState();

  // invoice_for_visa_cost_status
  console.log("quantities....quantities", visaCost);
  const getTableData = async () => {
    try {
      // alert("vfhjhfdjjhbfhjbjf.....hjdjgvhjvgjjhfbvjhfbjvhk")
      const response = await nodeinstance.get(
        `/dashboard/visaSecurity/getInvoice/${contractId?.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setData(response?.data?.data);
        setSummaryData(response?.data?.data);
      }
    } catch (erorr) {
      alert("error,,,.........");
    }
  };

  console.log("propData.....data...", propData);
  const totalQuantity = quantities?.reduce(
    (total, quantity) => total + parseInt(quantity),
    0
  );

  const visaCostNEW = quantities.map((quantity) => parseInt(quantity) * 2000);

  const totalVisaQuantity = visaCostNEW?.reduce(
    (total, visaCost) => total + parseInt(visaCost),
    0
  );

  let ActuallQuantityRequested = 0;

  Qunatity?.forEach((item) => {
    // if (item.cost_type === "SEC DEPOSIT") {
    const quantity = parseInt(item.quantity) || 0;
    ActuallQuantityRequested += quantity;
    // }
  });

  const handleQuantityChange = (index, newQuantity) => {
    // Update the quantity at the specified index
    const newQuantities = [...quantities];
    newQuantities[index] = newQuantity;
    console.log("Updated Quantities:", newQuantities);
    console.log("Updated visaCost:", newQuantities);

    // Set the updated arrays in state
    setQuantities(newQuantities);
    // setVisaCost(newVisaCost);
  };
  const handleDepositeChange = (index, newQuantity) => {
    if (parseInt(quantities[index]) > 0) {
      const newQuantities = [...depositecost];
      console.log("newQuantities......", newQuantities);

      newQuantities[index] = newQuantity;

      console.log(
        "Multiplication result.....",
        newQuantities[index] * quantities[index]
      );

      SetDepositeCost(newQuantities);
    } else {
      dispatch(
        setAppError({
          msg: "Quantity should be greater than 0.",
        })
      );
    }
  };

  console.log("......deposit.......", depositecost);
  const totalDepositeCost = depositecost?.reduce((total, quantity) => {
    // Parse quantity as an integer and default to 0 if it's not a number
    const parsedQuantity = parseInt(quantity) || 0;
    return total + parsedQuantity;
  }, 0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseData = await getTableData();
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error if necessary
      }
    };

    fetchData();
  }, [trigger]);

  const handleCheckboxChange = (value) => {
    setSelectedOption(value);
  };

  const [type, setType] = useState();

  const handleTypeChange = (value) => {
    setType(value);
    setSelectedOption("");
  };
  const dropDownData = [
    {
      name: "APPLICABLE",
    },
    {
      name: "INVOICE RAISED FULL",
    },
    {
      name: "INVOICE RAISED PARTIALLY",
    },
    {
      name: "PARTIAL PAYMENT RECEIVED",
    },
    {
      name: "FULL PAYMENT RECEIVED",
    },
    {
      name: "PENDING",
    },
  ];

  const onDropChange = (event) => {
    console.log("hegcuygug");
    setSecData(event.target.value);
  };
  const handleVisaSecChange = (e) => {
    setSecDepositeDrop(e.target.value);
  };
  console.log("visaCost....visaCost......", data);

  const [downloadReady, setDownloadReady] = useState(false);
  const downloadButtonRef = useRef(null);
  const [pdfData, setPdfData] = useState();

  const token = localStorage.getItem("nodeToken");

  const handlevisacostcommentschange = (e) => {
    setVisaCostComments(e.target.value);
  };
  const [buttonLoading, setButtonLoading] = useState(false);

  const onStatusChange = async () => {
    try {
      const reqObject = {
        finance_comments: secComments,
        comments_for_finance: visacostcomments,
        invoice_for_visa_cost_status: secData ? secData : "PENDING",
        invoice_for_security_deposit_status: secDepositeDropDown
          ? secDepositeDropDown
          : "PENDING",
        visa_sec_deposit_status: "YES",
      };
      console.log("nnnnnnmmmmm.........", reqObject);
      const response = await nodeinstance.put(
        `/dashboard/visaSecurity/statusUpdate/${contractId?.id}`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Updated successfully..",
            color: "success",
          })
        );
      }
    } catch (error) {
      console.log("error.....error", error);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  useEffect(() => {
    setDownloadReady(true);
  }, [downloadReady]);
  console.log("data......data...data", data);
  console.log("quantities......quantities", data);

  const totalInvoiceRaised = () => {
    if (quotationType === "Hourly" || quotationType === "Monthly") {
      return data?.data.reduce((total, item) => {
        if (item.cost_type === "SEC DEPOSIT") {
          return total + (item.total_invoices_raised || 0);
        }
        // setPendingTotal(total);
        return total;
      }, 0);
    } else if (quotationType === "Cost Plus") {
      return data?.data.reduce((total, item) => {
        if (item.cost_type === "VISA COST") {
          return total + (item.total_invoices_raised || 0);
        }
        // setPendingTotal(total);
        return total;
      }, 0);
    }
  };
  let pendingTotal = totalInvoiceRaised();
  console.log("totalInvoiceRaised......", quotationType);

  const totalInvoicePending = Qunatity?.reduce((total, item) => {
    const quantity = typeof item.quantity === "number" ? item.quantity : 0;
    return total + quantity;
  }, 0);

  console.log(
    "totalAdditionalInvoicesRaised - ActuallQuantityRequested",
    totalInvoicePending
    // ActuallQuantityRequested
  );

  useEffect(() => {
    console.log("data to be printed here........", data);
    setSecData(data?.contractData?.invoice_for_security_deposit_status);
    setSecDepositeDrop(data?.contractData?.invoice_for_visa_cost_status);
    setVisaCostComments(data?.contractData?.comments_for_finance);
  }, [data]);
  console.log(
    " ActuallQuantityRequested - totalInvoiceRaised()",
    totalInvoiceRaised()
  );

  const onSubmit = async () => {
    try {
      if (type === "SEC DEPOSIT") {
        if (
          selectedOption === null ||
          selectedOption === undefined ||
          selectedOption === ""
        ) {
          dispatch(
            setAppError({
              msg: "Months are required..",
            })
          );
          setButtonLoading(false);
          return;
        }
        console.log("quantities to be checked here....", quantities);
        if (quantities?.length <= 0) {
          dispatch(
            setAppError({
              msg: "Quantity is required....",
            })
          );
          return;
        }
        const reqObject = propData
          ?.map((data, i) => {
            const quantity = parseInt(quantities[i], 10); // Ensure quantity is parsed as a base 10 integer
            const invoiceAmount = totalDepositeCost;

            // Check if quantity is valid (not NaN, not null, and greater than 0)
            if (quantity && quantity > 0) {
              return {
                actual_profession_id: data?.actual_professionId,
                profession_level: data?.profession_level,
                profession_level_id: data?.profession_levelId,
                quantity: quantity,
                total_invoices_raised: totalQuantity,
                invoice_amount: invoiceAmount,
                months: selectedOption,
              };
            }
            return null;
          })
          .filter((item) => item !== null);
        console.log("reqObject to be printed here....", reqObject);
        if (reqObject?.length > 0) {
          const finalObject = {
            data: reqObject,
            ActuallQuantityRequested: ActuallQuantityRequested,
            quotation_type: quotationType,
            type: "SEC DEPOSIT",
          };
          console.log("finalObjectfinalObject", finalObject);
          const response = await nodeinstance.post(
            `/dashboard/visaSecurity/quantity/${contractId?.id}`,
            finalObject,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status === 200) {
            console.log("Data to be seen here from now....", response?.data);
            setPdfData(response?.data);
            console.log("Data to be printed.......", response);
            getTableData();
            setDownloadReady(true);
            setTimeout(() => {
              if (downloadReady && downloadButtonRef.current) {
                downloadButtonRef.current.click();
              }
              setSelectedData([]);
              setQuantities([]);
              SetDepositeCost([]);
              setButtonLoading(false);
              setSelectedOption("");
            }, 1000);
          }
        }
        return;
      }
      if (type === "VISA COST") {
        if (quantities?.length <= 0) {
          dispatch(
            setAppError({
              msg: "Quantity is required....",
            })
          );
          return;
        }
        const reqObject = propData
          ?.map((data, i) => {
            const quantity = parseInt(quantities[i], 10);

            // Check if quantity is valid (not null, not NaN, and greater than 0)
            if (quantity && quantity > 0) {
              return {
                actual_profession_id: data?.actual_professionId,
                profession_level: data?.profession_level,
                profession_level_id: data?.profession_levelId,
                quantity: quantity,
                total_invoices_raised: totalQuantity,
                invoice_amount: totalVisaQuantity,
                months: 0,
              };
            }
            return null;
          })
          .filter((item) => item !== null); // Filter out any null values
        if (reqObject?.length > 0) {
          const finalObject = {
            data: reqObject,
            ActuallQuantityRequested: ActuallQuantityRequested,
            quotation_type: quotationType,
            type: "VISA COST",
          };
          const response = await nodeinstance.post(
            `/dashboard/visaSecurity/quantity/${contractId?.id}`,
            finalObject,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status === 200) {
            console.log("Data to be seen here from now....", response?.data);
            setPdfData(response?.data);
            console.log("Data to be printed.......", response);
            getTableData();
            setDownloadReady(true);
            setTimeout(() => {
              if (downloadReady && downloadButtonRef.current) {
                downloadButtonRef.current.click();
              }
              setSelectedData([]);
              setQuantities([]);
              SetDepositeCost([]);
              setButtonLoading(false);
              setSelectedOption("");
            }, 1000);
          }
          return;
        }
        console.log("......reqObject print check....", reqObject);
        return;
      }
    } catch (error) {
      console.log("error......", error);
    }
  };

  const onSibmitHourly_Monthly = async () => {
    console.log("..........");
    try {
      // if (type === "SEC DEPOSIT") {
      if (
        selectedOption === null ||
        selectedOption === undefined ||
        selectedOption === ""
      ) {
        dispatch(
          setAppError({
            msg: "Months are required..",
          })
        );
        setButtonLoading(false);
        return;
      }
      console.log("quantities to be checked here....", quantities);
      if (quantities?.length <= 0) {
        dispatch(
          setAppError({
            msg: "Quantity is required....",
          })
        );
        return;
      }
      const reqObject = propData
        ?.map((data, i) => {
          const quantity = parseInt(quantities[i], 10); // Ensure quantity is parsed as a base 10 integer
          const invoiceAmount = totalDepositeCost;

          // Check if quantity is valid (not NaN, not null, and greater than 0)
          if (quantity && quantity > 0) {
            return {
              actual_profession_id: data?.actual_professionId,
              profession_level: data?.profession_level,
              profession_level_id: data?.profession_levelId,
              quantity: quantity,
              total_invoices_raised: totalQuantity,
              invoice_amount: invoiceAmount,
              months: selectedOption,
            };
          }
          return null;
        })
        .filter((item) => item !== null);
      console.log("reqObject to be printed here....", reqObject);
      if (reqObject?.length > 0) {
        const finalObject = {
          data: reqObject,
          ActuallQuantityRequested: ActuallQuantityRequested,
          quotation_type: quotationType,
          type: "SEC DEPOSIT",
        };
        console.log("finalObjectfinalObject", finalObject);
        const response = await nodeinstance.post(
          `/dashboard/visaSecurity/quantity/${contractId?.id}`,
          finalObject,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          console.log("Data to be seen here from now....", response?.data);
          setPdfData(response?.data);
          console.log("Data to be printed.......", response);
          getTableData();
          setDownloadReady(true);
          setTimeout(() => {
            if (downloadReady && downloadButtonRef.current) {
              downloadButtonRef.current.click();
            }
            setSelectedData([]);
            setQuantities([]);
            SetDepositeCost([]);
            setButtonLoading(false);
            setSelectedOption("");
          }, 1000);
        }
      }
      return;
      // }
    } catch (error) {
      console.log("error to be seen here....", error);
      dispatch(
        setAppError({
          msg: "Something went wrong!!! please try again.",
        })
      );
    }
  };

  return (
    <>
      <div
        className="flex flex-col w-full gap-1 my-2 overflow-x-hidden overflow-x-auto pl-16 pt-8 mt-3"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "0", // Add padding for space on the sides
          marginLeft: "10px",
        }}
      >
        <div
          className="!uppercase"
          style={{ maxHeight: "250px", overflowY: "auto" }}
        >
          {/* Row for 3 MONTH and 4 MONTH Checkboxes */}
          {quotationType === "Cost Plus" ? (
            <div className="flex mt-2">
              <label className="mr-4">
                <input
                  className="ml-2"
                  type="checkbox"
                  checked={type === "VISA COST"}
                  disabled={contractId.invoice_for_visa_cost === "NO"}
                  onChange={() => handleTypeChange("VISA COST")}
                />
                <span className="ml-2">VISA COST</span>
              </label>
              <label className="mr-4 ml-3">
                <input
                  type="checkbox"
                  checked={type === "SEC DEPOSIT"}
                  disabled={contractId.invoice_for_security_deposit === "NO"}
                  onChange={() => handleTypeChange("SEC DEPOSIT")}
                />
                <span className="ml-2">SEC DEPOSIT</span>
              </label>
            </div>
          ) : (
            ""
          )}
          <div className="flex ml-20">
            <label className="mr-10 ml-10">
              <input
                className="ml-5"
                type="checkbox"
                checked={selectedOption === "1"}
                onChange={() => handleCheckboxChange("1")}
                disabled={type === "VISA COST"}
              />
              <span className="ml-2">1 MONTH</span>
            </label>
            <label className="mr-5">
              <input
                type="checkbox"
                checked={selectedOption === "2"}
                onChange={() => handleCheckboxChange("2")}
                disabled={type === "VISA COST"}
              />
              <span className="ml-2">2 MONTH</span>
            </label>
          </div>

          {/* </div> */}
          <div className="flex flex-col w-full gap-1 pl-5 pt-14">
            <div className="flex">
              {Data.map((section, sectionIndex) => (
                <div className="flex flex-col relative" key={sectionIndex}>
                  <div className={`flex w-full gap-1`}>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      style={{ fontSize: "12px", fontWeight: "10px" }}
                    >
                      ACTUAL PROFESSION
                    </h3>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      style={{ fontSize: "12px" }}
                    >
                      PROFESSION LEVEL
                    </h3>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      style={{ fontSize: "12px" }}
                    >
                      QUANTITY
                    </h3>
                    {quotationType === "Cost Plus" ? (
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading2[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        style={{ fontSize: "12px" }}
                      >
                        VISA COST
                      </h3>
                    ) : (
                      ""
                    )}

                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      style={{ fontSize: "12px" }}
                    >
                      Security deposit cost
                    </h3>
                  </div>
                  <div className="mb-2">
                    {propData?.map((data, index) => (
                      <div
                        className="flex w-full gap-1 relative mb-2 mt-2"
                        key={index}
                      >
                        {/* <div className="flex gap-1 absolute"></div> */}
                        <p
                          className={`bg-slate-200 flex items-center text-sm justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.actual_profession}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {data.profession_level}
                        </p>

                        <input
                          type="number"
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                          style={{ lineHeight: `${tableProperties.colHeight}` }}
                          value={quantities && quantities[index]}
                          required
                          onChange={(e) =>
                            handleQuantityChange(index, e.target.value)
                          }
                        />
                        {quotationType === "Cost Plus" ? (
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {type === "SEC DEPOSIT"
                              ? 0
                              : visaCostNEW[index]
                                ? visaCostNEW[index]
                                : 0}
                          </p>
                        ) : (
                          ""
                        )}

                        <input
                          type="number"
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                          style={{
                            lineHeight: `${tableProperties.colHeight}`,
                          }}
                          value={
                            type === "VISA COST"
                              ? ""
                              : depositecost && depositecost[index]
                          }
                          disabled={
                            contractId?.invoice_for_security_deposit != "YES" ||
                            type === "VISA COST" ||
                            parseInt(quantities[index]) <= 0
                          }
                          required
                          // pattern="^[1-9][0-9]*$"
                          onChange={(e) =>
                            handleDepositeChange(index, e.target.value)
                          }
                        />
                      </div>
                    ))}
                  </div>
                  <div className={`flex w-full gap-1`}>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      style={{ fontSize: "9px" }}
                    ></h3>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      style={{ fontSize: "15px" }}
                    >
                      <strong>TOTAL</strong>
                    </h3>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      style={{ fontSize: "20px" }}
                    >
                      {totalQuantity ? totalQuantity : ""}
                    </h3>
                    {quotationType === "Cost Plus" ? (
                      <h3
                        className={`flex justify-center items-center text-sm ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        style={{ fontSize: "20px" }}
                      >
                        {type === "SEC DEPOSIT"
                          ? ""
                          : totalVisaQuantity
                            ? totalVisaQuantity
                            : ""}
                      </h3>
                    ) : (
                      ""
                    )}
                    <h3
                      className={`flex justify-center items-center text-sm ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      style={{ fontSize: "20px" }}
                    >
                      {type === "VISA COST"
                        ? ""
                        : totalDepositeCost
                          ? totalDepositeCost
                          : ""}
                    </h3>
                  </div>
                  {quotationType === "Cost Plus" ? (
                    <div
                      className="flex gap-3 w-full justify-center"
                      style={{ margin: 2 }}
                    >
                      <button
                        className="p-1 bg-red text-white rounded-md max-w-sm m-3 my-3 flex gap-1 justify-center items-center"
                        style={{ padding: "0.5rem", fontSize: "1rem" }}
                        onClick={() => {
                          onSubmit();
                        }}
                        disabled={propData?.length <= 0}
                      >
                        <p>Submit</p>
                        {buttonLoading && (
                          <CgSpinner className="animate-spin" />
                        )}
                      </button>
                    </div>
                  ) : (
                    <div
                      className="flex gap-3 w-full justify-center"
                      style={{ margin: 2 }}
                    >
                      <button
                        className="p-1 bg-red text-white rounded-md max-w-sm m-3 my-3 flex gap-1 justify-center items-center"
                        style={{ padding: "0.5rem", fontSize: "1rem" }}
                        onClick={() => {
                          onSibmitHourly_Monthly();
                        }}
                        disabled={propData?.length <= 0}
                      >
                        <p>Submit</p>
                        {buttonLoading && (
                          <CgSpinner className="animate-spin" />
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="!uppercase" style={{ flex: "1 1" }}>
          <div className="flex flex-col w-full gap-1 pl-16 mt-5">
            <div className="flex mb-11">
              {Data.map((section, sectionIndex) => (
                <div className="flex flex-col relative" key={sectionIndex}>
                  <div className={`flex w-full gap-1`}>
                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2_SUB[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                      style={{ fontSize: "12px" }}
                    >
                      INVOICE SUMMARY
                    </h3>
                    {quotationType === "Cost Plus" ? (
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading2_SUB[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                        style={{ fontSize: "12px" }}
                      >
                        Visa Quantity
                      </h3>
                    ) : (
                      ""
                    )}
                    <h3
                      className={`flex justify-center items-center text-sm ${tableHeading2_SUB[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                      style={{ fontSize: "12px" }}
                    >
                      Sec. Deposit Quantity
                    </h3>
                  </div>
                  <div className="mb-2">
                    <div className="flex w-full gap-1 relative mb-2 mt-2">
                      <div className="flex gap-1 absolute"></div>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        TOTAL INVOICE RAISED
                      </p>
                      {quotationType === "Cost Plus" ? (
                        data && data.data && data.data.length > 0 ? (
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                          >
                            {data?.visaCostCount ? data?.visaCostCount : 0}
                          </p>
                        ) : (
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                          >
                            0
                          </p>
                        )
                      ) : (
                        ""
                      )}
                      {data && data.data && data.data.length > 0 ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          {data?.totalSecDepositQuantity
                            ? data?.totalSecDepositQuantity
                            : 0}
                        </p>
                      ) : (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          0
                        </p>
                      )}
                    </div>
                    <div className="flex w-full gap-1 relative mb-2 mt-2">
                      <div className="flex gap-1 absolute"></div>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        TOTAL INVOICE PENDING
                      </p>
                      {quotationType === "Cost Plus" ? (
                        data?.visaCostCount > ActuallQuantityRequested ? (
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                          >
                            {" "}
                            {"0"}
                          </p>
                        ) : (
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                          >
                            {ActuallQuantityRequested - data?.visaCostCount <= 0
                              ? 0
                              : ActuallQuantityRequested - data?.visaCostCount}
                          </p>
                        )
                      ) : (
                        ""
                      )}
                      {data?.totalSecDepositQuantity >
                      ActuallQuantityRequested ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          {" "}
                          {"0"}
                        </p>
                      ) : (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          {ActuallQuantityRequested -
                            data?.totalSecDepositQuantity <=
                          0
                            ? 0
                            : ActuallQuantityRequested -
                              data?.totalSecDepositQuantity}
                        </p>
                      )}
                    </div>
                    <div className="flex w-full gap-1 relative mb-2 mt-2">
                      <div className="flex gap-1 absolute"></div>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        TOTAL ADDL. INVOICE RAISED
                      </p>
                      {quotationType === "Cost Plus" ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                        >
                          {data?.visaCostCount > ActuallQuantityRequested
                            ? data?.visaCostCount - ActuallQuantityRequested
                            : 0}
                        </p>
                      ) : (
                        ""
                      )}
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        {data?.totalSecDepositQuantity >
                        ActuallQuantityRequested
                          ? data?.totalSecDepositQuantity -
                            ActuallQuantityRequested
                          : 0}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="!uppercase m-2">
          <div className="flex flex-col w-full pl-12">
            <div className="flex flex-col gap-1 w-full max-w-md">
              <label htmlFor={`addOrEdit-name`} style={{ fontSize: "10px" }}>
                SEC.DEPOSIT STATUS
              </label>
              <select
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-3 text-md"
                value={secData ? secData : ""}
                onChange={onDropChange}
              >
                <option>{"select value"}</option>
                {dropDownData?.map((data, index) => (
                  <React.Fragment key={index}>
                    <option value={data.name}>{data.name}</option>
                  </React.Fragment>
                ))}
              </select>
            </div>
            {quotationType === "Cost Plus" ? (
              <div className="flex flex-col gap-1 w-full max-w-md mt-2">
                <label htmlFor={`addOrEdit-name`} style={{ fontSize: "10px" }}>
                  VISA COST STATUS
                </label>
                <select
                  // {...register("visaprovider")}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-4 text-md"
                  value={secDepositeDropDown ? secDepositeDropDown : ""}
                  onChange={handleVisaSecChange}
                >
                  <option>{"select value"}</option>
                  {dropDownData?.map((data, index) => (
                    <React.Fragment key={index}>
                      <option value={data.name}>{data.name}</option>
                    </React.Fragment>
                  ))}
                </select>
              </div>
            ) : (
              ""
            )}
            <label htmlFor={`addOrEdit-name`} style={{ fontSize: "10px" }}>
              Comments for finance
            </label>
            <div className="flex flex-col mt-2 gap-1 w-full max-w-md">
              <input
                type="text"
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-4 text-md"
                placeholder="Enter your comments here"
                defaultValue={
                  secComments
                    ? secComments
                    : data?.contractData?.finance_comments
                }
                onChange={(e) => {
                  setSecComments(e.target.value);
                }}
              />
            </div>
          </div>

          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 ml-40 m-2"
            onClick={() => {
              onStatusChange();
            }}
          >
            Save
          </button>
        </div>
        {quotationType === "Monthly" || quotationType === "Hourly" ? (
          <>
            <div className="!uppercase mb-12">
              <div className="flex flex-col w-full pl-16">
                <label
                  htmlFor={`addOrEdit-name`}
                  className="text-xs mt-4"
                  style={{ fontSize: "13px" }}
                >
                  Comments by ops1
                </label>
                <div className="flex flex-col mt-2 gap-1 w-full max-w-md">
                  <input
                    type="text"
                    className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-14 text-md"
                    placeholder="Comments for Finance"
                    value={visacostcomments}
                    onChange={handlevisacostcommentschange}
                    disabled
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="!uppercase mb-12">
            <div className="flex flex-col w-full pl-16">
              <label
                htmlFor={`addOrEdit-name`}
                className="text-xs mt-4"
                style={{ fontSize: "13px" }}
              >
                Comments by ops1
              </label>
              <div className="flex flex-col mt-2 gap-1 w-full max-w-md">
                <textarea
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 text-md"
                  placeholder="Enter your comments here"
                  value={visacostcomments ? visacostcomments : ""}
                  onChange={handlevisacostcommentschange}
                  disabled
                  rows={8} // Adjust the number of rows as needed
                  style={{ resize: "vertical" }} // Allows user to resize vertically
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
